// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1gg-p","spinner":"Loader_spinner__1VcZc","loadingText":"Loader_loadingText__3pBaK"};